export const ROUTES = {
    LOGIN: "/login",
    IP_NOT_WHITELISTED: "/ip-not-whitelisted",
    SSO_COMPLETE: "/sso-complete",
    PASSWORD_RESET: "/password-reset",
    NOTIFICATION_CHANNEL_VALIDATION: "/validate-channel",
    ROOT: "/",
    MAP: "/map",
    MAP_V2: "/map-v2",
    EMISSIONS: "/emissions",
    EMISSION_RECORDS: "/emission-records",
    ANALYTICS: "/analytics",
    INFRASTRUCURE: "/infrastructure",
    INFRASTRUCTURE_SITE: "/infrastructure/site",
    DATAUPLOADS: "/data-uploads",
    DATADOWNLOAD: "/data-download",
    EMISSION_EVENTS: "/emission-events",
    SETTINGS_HOME: "/settings",
    SETTINGS_NOTIFICATIONS: "/settings/notifications",
    SETTINGS_MOBILE_DEVICES: "/settings/mobile-devices",
    // Dashboard
    DASHBOARD: "/dashboard",
    DASHBOARD_ALL: "/dashboard/all",
    DASHBOARD_THIRD_PARTY: "/dashboard/3rd-party",
    DASHBOARD_SELF_REPORTED: "/dashboard/self-reported",
    DASHBOARD_UNMATCHED_DATA: "/dashboard/unmatched-data",
    DASHBOARD_EPA_SEP: "/dashboard/epa-super-emitter",
    // Admin views
    ADMIN_DASHBOARD: "/admin",
    ADMIN_DATA_IMPORT: "/admin/data-imports",
    ADMIN_STATS: "/admin/stats",
    ADMIN_DJANGO_ADMIN: "/admin/django-admin",
    ADMIN_VIEW_AS_COMPANY: "/admin/view-as-company",
    ADMIN_WORKFLOWS: "/admin/workflows",
    ADMIN_WORKFLOW_EDITOR: "/admin/workflows/:definitionId",
    // Static pages
    LICENSING: "/licensing",
    SUPPORT: "/support",
    PRIVACY_POLICY: "/privacy-policy",
    TERMS_OF_SERVICE: "/terms-of-service",
    AERSAGE: "/aersage-landing",
    // Error page, mostly for testing
    ERROR_PAGE: "/oops",
};
